// extracted by mini-css-extract-plugin
export default {"StatusBadgeIcon":"StatusBadgeIcon_StatusBadgeIcon__4LohU","value":"StatusBadgeIcon_value__6sanI","iconContainer":"StatusBadgeIcon_iconContainer__URePw"};